import { render, staticRenderFns } from "./DisciplinaryCard.vue?vue&type=template&id=6c170680"
import script from "./DisciplinaryCard.vue?vue&type=script&lang=js"
export * from "./DisciplinaryCard.vue?vue&type=script&lang=js"
import style0 from "./DisciplinaryCard.vue?vue&type=style&index=0&id=6c170680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports